import React from 'react';
import { Link } from 'react-router-dom';

const Transparency = () => {
  const sectionTitleStyle = {
      color: '#003366',
      borderBottom: '2px solid #003366',
      paddingBottom: '10px',
      marginBottom: '20px',
      fontSize: '18px',
      fontFamily: 'serif',
      textTransform: 'uppercase'
  };

  // Documents Data (Isay aap backend se bhi la sakte hain)
  const activityPlans = [
    {
      id: 1,
      date: '17-11-2021',
      category: 'Activity plans',
      title: 'Government action plan for 2021-2022',
      // Aapki PDF ka naam (public folder mein honi chahiye)
      fileUrl: '/documents/hg_nr.235_13.10.2021-engl.pdf', 
      fileName: 'hg_nr.235_13.10.2021-engl.pdf',
      type: 'pdf'
    },
    {
      id: 2,
      date: '16-12-2019',
      category: 'Activity plans',
      title: 'Government action plan for 2020-2023',
      fileUrl: '/documents/pag_2020-2023.eng_.pdf',
      fileName: 'pag_2020-2023.eng_.pdf',
      type: 'pdf'
    },
    {
      id: 3,
      date: '11-12-2019',
      category: 'Activity plans',
      title: 'The activity Program of the Government led by Ion Chicu',
      fileUrl: '/documents/planul_de_actiuni_al_guvernului_chicu_en.pdf',
      fileName: 'planul_de_actiuni_al_guvernului_chicu_en.pdf',
      type: 'pdf'
    },
    {
      id: 4,
      date: '03-09-2014',
      category: 'Activity plans',
      title: 'EN - Hotărârea Guvernului cu privire la aprobarea Planului de activitate al Guvernului pentru anul 2010',
      // External URL example
      fileUrl: 'http://lex.justice.md/index.php?action=view&view=doc&lang=1&id=337937',
      fileName: 'http://lex.justice.md/index.php?action=view&view=doc&lang=1&id=337937',
      type: 'link'
    }
  ];

  return (
    <div className="container mt-5 mb-5">
      <div className="row">

        {/* === LEFT COLUMN: Transparency Menu === */}
        <div className="col-lg-3 mb-4">
            <h4 style={sectionTitleStyle}>DECISIONAL TRANSPARENCY</h4>
            <div className="list-group list-group-flush font-serif">
                {/* Active Item */}
                <Link to="/transparency" className="list-group-item list-group-item-action text-primary fw-bold border-0 ps-0 bg-transparent">
                    <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Activity plans
                </Link>
                {/* Other Items */}
                <a href="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0 bg-transparent">
                    <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> National Council for Participation
                </a>
                <a href="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0 bg-transparent">
                    <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Public consultations
                </a>
            </div>
        </div>

        {/* === CENTER COLUMN: Activity Plans List === */}
        <div className="col-lg-6 mb-4">
            <h4 style={sectionTitleStyle}>ACTIVITY PLANS</h4>

            <div className="d-flex flex-column gap-3">
                {activityPlans.map(item => (
                    <div className="p-3 bg-light border-start border-4 border-secondary" style={{backgroundColor: '#f8f9fa'}} key={item.id}>
                        {/* Meta Data */}
                        <div className="text-muted small mb-2">
                            <i className="fa fa-calendar me-2"></i> {item.date} <span className="mx-2">|</span> {item.category}
                        </div>
                        
                        {/* Title */}
                        <h6 className="fw-bold mb-2" style={{color: '#003366', fontFamily: 'serif'}}>
                            {item.title}
                        </h6>

                        {/* File Link */}
                        <div className="d-flex align-items-center">
                            {/* Icon based on type */}
                            {item.type === 'pdf' ? (
                                <i className="fa fa-file-pdf-o me-2 fs-5" style={{color: '#003366'}}></i>
                            ) : (
                                <i className="fa fa-globe me-2 fs-5" style={{color: '#003366'}}></i>
                            )}
                            
                            {/* The Link - Opens in New Tab */}
                            <a href={item.fileUrl} target="_blank" rel="noreferrer" className="text-decoration-underline small" style={{color: '#003366'}}>
                                {item.fileName}
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>

        {/* === RIGHT COLUMN: Agenda & Widget === */}
        <div className="col-lg-3">
            <h4 style={sectionTitleStyle}>AGENDA</h4>
            
            {/* Calendar Widget */}
            <div className="bg-white border rounded shadow-sm p-0 mb-4">
                <div className="d-flex justify-content-between align-items-center text-white p-2" style={{backgroundColor: '#003366'}}>
                    <button className="btn btn-sm text-white"><i className="fa fa-chevron-left"></i></button>
                    <span className="fw-bold">January 2026</span>
                    <button className="btn btn-sm text-white"><i className="fa fa-chevron-right"></i></button>
                </div>
                <div className="p-2">
                    <table className="table table-sm text-center border-0 mb-0" style={{fontSize: '12px'}}>
                        <thead>
                            <tr className="text-primary fw-bold">
                                <th>M</th><th>T</th><th>W</th><th>T</th><th>F</th><th>S</th><th>S</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td></td><td></td><td></td><td className="text-danger fw-bold border border-danger">1</td><td>2</td><td>3</td><td>4</td></tr>
                            <tr><td>5</td><td>6</td><td>7</td><td>8</td><td>9</td><td>10</td><td>11</td></tr>
                            <tr><td>12</td><td>13</td><td>14</td><td>15</td><td>16</td><td>17</td><td>18</td></tr>
                            <tr><td>19</td><td>20</td><td>21</td><td>22</td><td>23</td><td>24</td><td>25</td></tr>
                            <tr><td>26</td><td>27</td><td>28</td><td>29</td><td>30</td><td>31</td><td></td></tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Blue Bubble Widget */}
            <div className="d-flex justify-content-end mt-5">
                <div className="position-relative text-end" style={{maxWidth:'200px'}}>
                    <div className="bg-primary text-white p-3 rounded shadow" style={{backgroundColor: '#336699 !important', fontSize:'12px'}}>
                         <div className="d-flex justify-content-between align-items-start mb-2">
                            <strong>EUROPA PENTRU TINE!</strong>
                            <i className="fa fa-times-circle opacity-50" style={{cursor:'pointer'}}></i>
                         </div>
                        Află despre beneficiile și oportunitățile oferite Republicii Moldova de Uniunea Europeană.
                    </div>
                    <div style={{
                        width: 0, height: 0, 
                        borderLeft: '10px solid transparent', 
                        borderRight: '10px solid transparent', 
                        borderTop: '15px solid #0d6efd', 
                        marginLeft: 'auto', marginRight: '20px'
                    }}></div>
                    <img src="/images/plan_eu.png" className="rounded-circle mt-2 shadow" width="60" alt="EU"/>
                </div>
            </div>
        </div>

      </div>
    </div>
  );
};

export default Transparency;
